import { SourceSettings } from '../source-settings';

export interface CalculatorSourceSettings extends SourceSettings {
  type: 'calculator';
  minQueryLength: number;
}
